export default "__VITE_PUBLIC_ASSET__cea2ba74__"